module.exports = __webpack_public_path__ + "media/images/ecalls/04_how_it_works_3-201e39f726fb0d6b9b888a667c22d07e.png";